import { render, staticRenderFns } from "./SwitchAccount.vue?vue&type=template&id=72f0e2c1"
import script from "./SwitchAccount.vue?vue&type=script&lang=js"
export * from "./SwitchAccount.vue?vue&type=script&lang=js"
import style0 from "./SwitchAccount.vue?vue&type=style&index=0&id=72f0e2c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports